export interface IFile {
    nombre: string;
    nombreOriginal: string;
    tipo: string;
    categoria: string;
    fechaSubido: string;
    size: string;
    extension: string;
    _id: string;
  }
  
 export interface IGraveViolacion {
    _id: string;
    nombre: string;
  }
  
 export interface IPersona {
    _id: string;
    nombre: string;
  }
  
 export interface ISubcontexto {
    _id: string;
    nombre: string;
  }
  
 export interface ILocalizacion {
    idEstado: number;
    estado: string;
    idMunicipio: number;
    municipio: string;
    idLocalidad: number;
    localidad: string;
    lugar: string;
    lat: number;
    lon: number;
    _id: string;
  }
  
 export interface IAnalisisContexto {
    id: string;
    _id: string;
  }
  
 export interface ITestimonio {
    _id: string;
    clasificacion: string;
    colectivo: string | null;
    duracion: string;
    emi: string;
    entidad: string;
    entrevistador: string;
    fecha: string;
    gravesViolaciones: IGraveViolacion[];
    grupoMilitancia: string;
    infoAdicional: string | null;
    lugar: string;
    materialAdicional: string;
    otrosFormatosTestimonios: string | null;
    persona: IPersona[];
    sesiones: string;
    subcontextos: ISubcontexto[];
    tipoEntrevista: string;
    tipoMaterialAdicional: string | null;
    tipoTestimoniante: string;
    tlaxcoaque: string;
    transcriptor: string;
    __v: number;
    files: IFile[];
    audios: IFile[];
    localizacion: ILocalizacion[];
    consecuencias: any[];
    sexo: string;
    causas: any[];
    factores: any[];
    analisisContexto: IAnalisisContexto[];
    estrategias: any[];
  }
// createMethods.ts
export const createFile = (data: Partial<IFile> = {}): IFile => ({
    ...data,
    nombre: data.nombre || "",
    nombreOriginal: data.nombreOriginal || "",
    tipo: data.tipo || "",
    categoria: data.categoria || "",
    fechaSubido: data.fechaSubido || "",
    size: data.size || "",
    extension: data.extension || "",
    _id: data._id || "",
  });
  
  export const createLocalizacion = (data: Partial<ILocalizacion> = {}): ILocalizacion => ({
    ...data,
    idEstado: data.idEstado || 0,
    estado : data.estado || "",
    idMunicipio: data.idMunicipio || 0,
    municipio: data.municipio || "",
    idLocalidad: data.idLocalidad || 0,
    localidad: data.localidad || "",
    lugar: data.lugar || "",
    lat: data.lat || 0,
    lon: data.lon || 0,    
    _id: data._id || "",

  });
  
  export const createAnalisisContexto = (data: Partial<IAnalisisContexto> = {}): IAnalisisContexto => ({
    ...data,
    id: data.id || "",
    _id: data._id || "",
  });
  
  export const createGraveViolacion = (data: Partial<IGraveViolacion> = {}): IGraveViolacion => ({
    ...data,
    _id: data._id || "",
    nombre: data.nombre || "",
  });
  
  export const createPersona = (data: Partial<IPersona> = {}): IPersona => ({
    ...data,
    _id: data._id || "",
    nombre: data.nombre || "",
  });
  
  export const createSubcontexto = (data: Partial<ISubcontexto> = {}): ISubcontexto => ({
    ...data,
    _id: data._id || "",
    nombre: data.nombre || "",
  });
  
  export const createTestimonio = (data: Partial<ITestimonio> = {}): ITestimonio => ({
    ...data,
    _id: data._id || "",
    clasificacion: data.clasificacion || "",
    colectivo: data.colectivo || "No pertenece a colectivo",
    duracion: data.duracion || "",
    emi: data.emi || "",
    entidad: data.entidad || "",
    entrevistador: data.entrevistador || "",
    fecha: data.fecha || "",
    gravesViolaciones: data.gravesViolaciones?.map(createGraveViolacion) || [],
    grupoMilitancia: data.grupoMilitancia || "",
    infoAdicional: data.infoAdicional || "Sin observaciones ",
    lugar: data.lugar || "",
    materialAdicional: data.materialAdicional || "",
    otrosFormatosTestimonios: data.otrosFormatosTestimonios || null,
    persona: data.persona?.map(createPersona) || [],
    sesiones: data.sesiones || "",
    subcontextos: data.subcontextos?.map(createSubcontexto) || [],
    tipoEntrevista: data.tipoEntrevista || "",
    tipoMaterialAdicional: data.tipoMaterialAdicional || null,
    tipoTestimoniante: data.tipoTestimoniante || "",
    tlaxcoaque: data.tlaxcoaque || "",
    transcriptor: data.transcriptor || "",
    __v: data.__v || 0,
    files: data.files?.map(createFile) || [],
    audios: data.audios?.map(createFile) || [],
    localizacion: data.localizacion?.map(createLocalizacion) || [],
    consecuencias: data.consecuencias || [],
    sexo: data.sexo || "",
    causas: data.causas || [],
    factores: data.factores || [],
    analisisContexto: data.analisisContexto?.map(createAnalisisContexto) || [],
    estrategias: data.estrategias || [],
  });
  